import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=504f71b2&scoped=true&"
import script from "./PublicFooter.vue?vue&type=script&lang=js&"
export * from "./PublicFooter.vue?vue&type=script&lang=js&"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=504f71b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f71b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFooter,VIcon,VRow})
